// React imports
import moment from "moment";
import React, { Component, Fragment } from "react";

// Material imports
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DownloadIcon from "@material-ui/icons/GetApp";

// Icon imports
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SearchIcon from "@material-ui/icons/Search";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Cancel";

// React Admin imports
import { Responsive, Title, translate } from "react-admin";
import { connect } from "react-redux";
import ButtonMenu from "../../components/ButtonMenu";
import {
  DestinationRow,
  EventAdTeaserCard,
  EventDateCard,
  SimpleCardWithoutHeader
} from "../../components/Cards";
import CompetitionInformationIcons from "../../components/CompetitionInformationIcons";
import SimpleList from "../../components/SimpleList";
import { setError } from "../../reducer/errorActions";
import restClient from "../../providers/dataProvider/rest";

// Other imports
import {
  cancelOrderItem,
  checkAuth,
  clickAd,
  exportCompetitorList as exportCompetitorListCall,
  getAdvertisingPage,
  getCompetitionsPub,
  getUserBookedCompetitions
} from "../../utils/restUtils";
import download from "downloadjs";

import { setPopup, togglePopup } from "../../reducer/flagActions";
import GenericPopup from "../../components/GenericPopup";
import { getAdsImageSrc } from "../../utils/imageUtils";
import { FILE_API_PATH } from "../../utils/config";
import { setSuccess } from "../../reducer/successActions";
import SuccessMessage from "../../components/SuccessMessage";
import HeroSection from "./HeroSection";
import { colors, layout, outlineButton } from "../../theme/tokens";

moment.locale("de-at");

const styles = {
  spacer: {
    display: "block",
    height: "20px"
  },
  marginBottom: {
    marginBottom: "20px"
  },
  card: {
    marginBottom: "20px"
  },
  cardTitleBgGreen: {
    backgroundColor: colors.brand,
    padding: "16px"
  },
  cardTitleBgPurple: {
    backgroundColor: colors.brandDeep,
    padding: "16px"
  },
  cardTitleBgBlue: {
    backgroundColor: colors.brand,
    padding: "16px"
  },
  cardTitle: {
    color: "#ffffff",
    display: "flex",
    minHeight: "40px",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  tableRow: {
    height: "auto",
    verticalAlign: "top"
  },
  tableCell: {
    borderBottomWidth: 0,
    padding: "4px 12px 4px 0"
  },
  tableCellDate: {
    borderBottomWidth: 0,
    padding: "4px 12px 4px 0",
    fontWeight: "700"
  },
  list: {
    padding: 0
  },
  listItem: {
    padding: "3px 0 8px 0"
  },
  button: {
    ...outlineButton
  },
  rightIcon: {
    fontSize: "18px",
    marginLeft: "6px"
  },
  root: {
    width: "100%"
  },
  // responsive page shell, like ".shell" in the prototype
  page: {
    width: "100%",
    maxWidth: layout.maxWidth,
    margin: "0 auto"
  },
  // tinted, full bleed band starting at the "competitions" section
  // (prototype: one separator line + tinted background down to the footer)
  tintedBand: {
    backgroundColor: colors.tinted,
    borderTop: "1px solid " + colors.line,
    // full bleed inside the 20px content padding of the layout
    margin: "72px -20px -20px",
    padding: "88px 20px 40px"
  },
  destinations: {
    paddingTop: "72px"
  },
  shooterSection: {
    paddingTop: "8px",
    paddingBottom: "16px"
  },
  shooterTitle: {
    color: colors.ink,
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: "1.1",
    letterSpacing: "-.045em",
    marginBottom: "28px"
  },
  sectionAside: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    maxWidth: "350px",
    paddingBottom: "4px"
  },
  sectionIntro: {
    color: colors.muted,
    fontSize: "15px",
    textAlign: "right",
    marginBottom: "12px"
  },
  sectionTitle: {
    color: colors.ink,
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "1.05",
    letterSpacing: "-.06em",
    marginBottom: "20px"
  },
  sectionHead: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: "38px"
  },
  eyebrow: {
    color: colors.brand,
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: ".14em",
    textTransform: "uppercase",
    marginBottom: "12px"
  },
  media: {
    height: 140
  },
  teaserButton: {
    color: colors.brand
  }
};

class Dashboard extends Component {
  state = {
    competitions: [],
    advertising: [],
    adPosition: Math.floor(Math.random() * 2) + 1
  };

  getPublicCompetitions = () => {
    var jsonString = JSON.stringify({
      year: [],
      month: [],
      country: [],
      zip: [],
      club: [],
      type: [],
      level: [],
      province: [],
      archive: false,
      competition: true
    });
    var filterString = encodeURI(jsonString);

    getCompetitionsPub(0, 3, "competitionDate", "asc", filterString).then(
      data => {
        for (let i = 0; i < data.data.length; i++) {
          let item = data.data[i];
          if (item.publicLink) {
            item.publicLinkAction = () => {
              this.props.dispatch(
                setPopup("popupCompetitionRegistrationForm", false)
              );
              this.props.history.push("/competitionDetails/" + item.publicLink);
            };
          }
          item.infoIcons = <CompetitionInformationIcons record={item} />;
        }

        this.setState({
          competitions: data.data
        });
      },
      e => {
        this.props.dispatch(setError(e));
      }
    );
  };

  exportCompetitorList = item => {
    exportCompetitorListCall(item.competitionId)
      .then(response => {
        return response.blob();
      })
      .then(
        data => {
          let filename = "teilnehmerliste.xlsx";

          download(
            data,
            filename,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
        },
        e => {
          this.props.dispatch(setError(e));
        }
      );
  };

  getUserBookedCompetitions = () => {
    getUserBookedCompetitions(0, 6, "competition.competitionDate", "asc", {
      archive: false
    }).then(
      data => {
        let items = [];
        let mainText;
        for (let i = 0; i < data.data.length; i++) {
          let item = data.data[i];
          if (item.publicLink) {
            item.publicLinkAction = () => {
              this.props.dispatch(
                setPopup("popupCompetitionRegistrationForm", false)
              );
              this.props.history.push("/competitionDetails/" + item.publicLink);
            };
          }
          let actions = [];
          actions.push({
            callBack: () => {
              this.props.dispatch(
                setPopup("popupCompetitionRegistrationForm", false)
              );
              this.props.history.push("/competitionDetails/" + item.publicLink);
            },
            text: "Details",
            icon: <SearchIcon />
          });
          if (item.paid) {
            actions.push({
              callBack: () => this.exportCompetitorList(item),
              text: "Teilnehmerliste",
              icon: <DownloadIcon />
            });
          }
          if (item.competitionUploads.length > 0) {
            item.competitionUploads.map((competitionUpload, key) =>
              actions.push({
                callBack: () =>
                  this.fetchFileFromBucket(competitionUpload.document.path),
                text: competitionUpload.type.showName
                  ? competitionUpload.document.fileName
                  : competitionUpload.type.name,
                icon: <DownloadIcon />
              })
            );
          }

          if (!item.cancelled) {
            actions.push({
              callBack: () => {
                this.props.history.push("shooterOrderItems/" + item.id);
              },
              text: "Bearbeiten",
              icon: <EditIcon />
            });
            actions.push({
              callBack: () => {
                this.props.dispatch(togglePopup("cancelOrderItemPopup"));
                this.setState({
                  clickedButton: { id: item.id, active: item.cancelled }
                });
              },
              text: "Abmelden",
              icon: <CancelIcon />
            });
          }

          if (item.cancelled == true) {
            mainText = item.competitionName + " (Abgemeldet)";
          } else {
            mainText = item.competitionName;
          }
          items.push({
            id: i,
            mainText: mainText,
            secondaryText: <CompetitionInformationIcons record={item} />,
            link: "",
            menu: <ButtonMenu buttonIcon={<MoreVertIcon />} options={actions} />
          });
        }

        this.setState({
          userBookedCompetitions: items
        });
      },
      e => {
        this.props.dispatch(setError(e));
      }
    );
  };

  getAdvertising = () => {
    getAdvertisingPage(0, 100, "id", "desc", {}).then(
      data => {
        this.setState({
          advertising: data.data
        });
      },
      e => {
        this.props.dispatch(setError(e));
      }
    );
  };

  getUserParticipatedCompetitions = () => {
    getUserBookedCompetitions(0, 6, "competition.competitionDate", "desc", {
      archive: true
    }).then(
      data => {
        let items = [];
        for (let i = 0; i < data.data.length; i++) {
          let item = data.data[i];
          if (item.publicLink) {
            item.publicLinkAction = () => {
              this.props.dispatch(
                setPopup("popupCompetitionRegistrationForm", false)
              );
              this.props.history.push("/competitionDetails/" + item.publicLink);
            };
          }
          let actions = [];
          actions.push({
            callBack: () => {
              this.props.dispatch(
                setPopup("popupCompetitionRegistrationForm", false)
              );
              this.props.history.push("/competitionDetails/" + item.publicLink);
            },
            text: "Details",
            icon: <SearchIcon />
          });
          if (item.paid) {
            actions.push({
              callBack: () => this.exportCompetitorList(item),
              text: "Teilnehmerliste",
              icon: <DownloadIcon />
            });
          }
          if (item.competitionUploads.length > 0) {
            item.competitionUploads.map((competitionUpload, key) =>
              actions.push({
                callBack: () =>
                  this.fetchFileFromBucket(competitionUpload.document.path),
                text: competitionUpload.type.name,
                icon: <DownloadIcon />
              })
            );
          }
          items.push({
            id: i,
            mainText: item.competitionName,
            secondaryText: <CompetitionInformationIcons record={item} />,
            link: "",
            menu: <ButtonMenu buttonIcon={<MoreVertIcon />} options={actions} />
          });
        }

        this.setState({
          userParticipatedCompetitions: items
        });
      },
      e => {
        this.props.dispatch(setError(e));
      }
    );
  };

  handleCancel = () => {
    cancelOrderItem(this.state.clickedButton.id).then(
      data => {
        this.getUserBookedCompetitions();
        this.handleCancelClose();
      },
      e => {
        this.props.dispatch(setError(e));
      }
    );
  };

  handleCancelClose = () =>
    this.props.dispatch(togglePopup("cancelOrderItemPopup"));

  checkAuth = () => {
    checkAuth().then(success => {}, e => this.props.dispatch(setError(e)));
  };

  componentDidMount() {
    this.getAdvertising();
    this.getPublicCompetitions();
    /* TODO: check if user is logged in and is a competitive user!*/
    if (this.isShooter()) {
      this.getUserBookedCompetitions();
      this.getUserParticipatedCompetitions();
    }
    if (this.isClubAdmin() || this.isPortalAdmin() || this.isSystemAdmin())
      this.checkAuth();
  }

  componentDidUpdate = prevProps => {
    if (prevProps.identity !== this.props.identity) {
      if (this.isShooter()) {
        this.getUserBookedCompetitions();
        this.getUserParticipatedCompetitions();
      }
    }
  };

  getFreeSlots = record => {
    let totalSlots = 0;
    let bookedSlots = 0;
    let squads = record.squads || [];
    for (let i = 0; i < squads.length; i++) {
      totalSlots += squads[i].squadSize;
      bookedSlots +=
        squads[i].squadSize >= squads[i].subscriptionSize
          ? squads[i].subscriptionSize
          : squads[i].squadSize;
    }
    return totalSlots - bookedSlots;
  };

  getFreeSlotsText = record => {
    return (
      this.getFreeSlots(record) +
      (" " +
        this.props.translate(
          "resources.competitionshow.detailsTable.freePlaces"
        ))
    );
  };

  getStatusLabel = record => {
    const { translate } = this.props;
    if (!record.registration) {
      return null;
    }
    if (
      record.registrationStart &&
      moment(record.registrationStart).isAfter(moment())
    ) {
      return translate("dashboard.competitions.statusRegistrationSoon");
    }
    return this.getFreeSlots(record) > 0
      ? translate("dashboard.competitions.statusOpen")
      : translate("dashboard.competitions.statusFull");
  };

  isAuthenticated = () =>
    typeof this.props.identity !== "undefined" &&
    this.props.identity.userData.id;

  isSystemAdmin = () => {
    return (
      this.isAuthenticated() &&
      this.props.identity.userData.permissions.includes("IS_ADMIN")
    );
  };

  isPortalAdmin = () => {
    return (
      this.isAuthenticated() &&
      this.props.identity.userData.permissions.includes("IS_PORTAL_ADMIN")
    );
  };

  isClubAdmin = () => {
    return (
      this.isAuthenticated() &&
      this.props.identity.userData.permissions.includes("IS_CLUB_ADMIN")
    );
  };

  isShooter = () => {
    return (
      this.isAuthenticated() &&
      this.props.identity.userData.permissions.includes("IS_USER_SHOOTER")
    );
  };

  getFullName = () => {
    if (!this.isAuthenticated()) {
      return "";
    }
    return this.props.identity.userData.userFullName;
  };

  fetchFile = id => {
    restClient("DOWNLOAD", "download", {
      id: id
    }).then(response => {
      try {
        const filename = response.headers
          .get("Content-Disposition")
          .split("filename=")[1];
        response.blob().then(blob => {
          if (typeof callback !== "undefined") {
            return;
          }
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } catch (e) {
        console.log(e);
      }
    });
  };

  fetchFileFromBucket = filePath => {
    window.open(FILE_API_PATH + "/" + filePath);
  };

  handleAdClick = (id, detailView, href) => {
    clickAd(id);
    detailView
      ? this.props.history.push("/werbung/" + id)
      : window.open(href, "_blank");
  };

  renderCompetitionCards = () => {
    const { translate } = this.props;
    const ad = this.state.advertising[0];
    let cards = [];
    this.state.competitions.forEach((record, oKey) => {
      if (oKey == this.state.adPosition && ad) {
        cards.push(
          <Grid item xs={12} sm={6} md={4} key={"advert-" + oKey}>
            <EventAdTeaserCard
              handleAdClick={this.handleAdClick}
              translate={translate}
              image={getAdsImageSrc(ad)}
              header={ad.name}
              desc={ad.shortName}
              infoIcons={""}
              buttonLabel={ad.buttonText}
              detailView={ad.detailView}
              detailId={ad.id}
              href={ad.buttonLink}
            />
          </Grid>
        );
      }
      cards.push(
        <Grid item xs={12} sm={6} md={4} key={"competition-" + oKey}>
          <EventDateCard
            translate={translate}
            day={moment(record.competitionDate)
              .format("DD")
              .toString()}
            month={moment(record.competitionDate)
              .format("MMMM YYYY")
              .toString()}
            header={record.name}
            isEvent={record.event}
            statusLabel={this.getStatusLabel(record)}
            infoText={this.getFreeSlotsText(record)}
            infoIcons={record.infoIcons}
            buttonLabel={
              record.event
                ? translate("dashboard.competitions.btnEvent")
                : translate("dashboard.competitions.btnCompetition")
            }
            btnClickHandler={record.publicLinkAction}
            registration={record.registration}
            registrationStart={moment(record.registrationStart)
              .format("L")
              .toString()}
          />
        </Grid>
      );
    });
    return cards;
  };
  render() {
    const { classes, translate, ...rest } = this.props;
    return (
      <Fragment>
        <Title title="Compsign Admin" />
        <Responsive
          medium={
            <div style={styles.root}>
              <div style={styles.page}>
                <HeroSection
                  translate={translate}
                  showGuestInfo={!this.isAuthenticated()}
                  onRegisterClick={() =>
                    this.props.history.push("/userRegister")
                  }
                  links={[
                    {
                      label: translate("dashboard.hero.quickNavItems.results"),
                      onClick: () => this.props.history.push("/results")
                    },
                    {
                      label: translate(
                        "dashboard.hero.quickNavItems.competitions"
                      ),
                      onClick: () => this.props.history.push("/competitionList")
                    },
                    {
                      label: translate("dashboard.hero.quickNavItems.clubs"),
                      onClick: () => this.props.history.push("/clubList")
                    }
                  ]}
                  infoLinks={[
                    {
                      label: translate(
                        "dashboard.guestContent.registrationAdvantages"
                      ),
                      onClick: () =>
                        window.open(
                          "https://compsign.at/meine-vorteile-als-registrierter-schuetze/",
                          "_blank"
                        )
                    },
                    {
                      label: translate(
                        "dashboard.guestContent.compSignFunctions"
                      ),
                      onClick: () =>
                        window.open(
                          "https://compsign.at/ueber-compsign/",
                          "_blank"
                        )
                    }
                  ]}
                />
              </div>
              {this.isShooter() && (
                <div style={styles.page}>
                  <div style={styles.shooterSection}>
                    <Grid container spacing={40}>
                      <Grid item xs={12} sm={12} md={6}>
                        <GenericPopup
                          open={this.props.cancelOrderItemPopup}
                          handleConfirm={this.handleCancel}
                          handleClose={this.handleCancelClose}
                          message={this.props.translate(
                            "resources.orderList.shooterCancelOrderItemPopup.warning"
                          )}
                          title={this.props.translate(
                            "resources.orderList.shooterCancelOrderItemPopup.title"
                          )}
                          confirmText={this.props.translate(
                            "resources.orderList.shooterCancelOrderItemPopup.confirm"
                          )}
                          cancelText={this.props.translate(
                            "resources.orderList.shooterCancelOrderItemPopup.cancel"
                          )}
                        />
                        <Typography
                          variant="headline"
                          style={styles.shooterTitle}
                        >
                          {translate("dashboard.myUpcomingEvents.title")}
                        </Typography>
                        <SimpleCardWithoutHeader
                          content={
                            <SimpleList
                              data={this.state.userBookedCompetitions}
                              momentFormat={"L"}
                              locale={"de-at"}
                            />
                          }
                          buttonLabel={translate(
                            "dashboard.myUpcomingEvents.moreButton"
                          )}
                          btnClickHandler={() =>
                            this.props.history.push("/myCompetitions")
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <Typography
                          variant="headline"
                          style={styles.shooterTitle}
                        >
                          {translate("dashboard.myParticipatedEvents.title")}
                        </Typography>
                        <SimpleCardWithoutHeader
                          content={
                            <SimpleList
                              data={this.state.userParticipatedCompetitions}
                              momentFormat={"L"}
                              locale={"de-at"}
                            />
                          }
                          buttonLabel={translate(
                            "dashboard.myParticipatedEvents.moreButton"
                          )}
                          btnClickHandler={() =>
                            this.props.history.push("/myCompetitions")
                          }
                        />
                      </Grid>
                    </Grid>
                  </div>
                </div>
              )}
              <div style={styles.tintedBand}>
                <div style={styles.page}>
                  <div style={styles.sectionHead}>
                    <div>
                      <div style={styles.eyebrow}>
                        {translate("dashboard.competitions.eyebrow")}
                      </div>
                      <Typography
                        variant="display1"
                        style={styles.sectionTitle}
                      >
                        {translate("dashboard.competitions.headline")}
                      </Typography>
                    </div>
                    <div style={styles.sectionAside}>
                      <Typography variant="body1" style={styles.sectionIntro}>
                        {translate("dashboard.competitions.intro")}
                      </Typography>
                      <Button
                        onClick={() =>
                          this.props.history.push("/competitionList")
                        }
                        style={styles.button}
                      >
                        {translate("dashboard.competitions.btnAllCompetitions")}
                        <KeyboardArrowRight style={styles.rightIcon} />
                      </Button>
                    </div>
                  </div>
                  <Grid container spacing={16}>
                    {this.renderCompetitionCards()}
                  </Grid>
                  <div style={styles.destinations}>
                    <DestinationRow
                      eyebrow={translate("dashboard.teaser.results.headline")}
                      title={translate("dashboard.destinations.results.title")}
                      buttonLabel={translate(
                        "dashboard.destinations.results.button"
                      )}
                      btnClickHandler={() =>
                        this.props.history.push("/results")
                      }
                    />
                    <DestinationRow
                      eyebrow={translate("dashboard.teaser.clubs.headline")}
                      title={translate("dashboard.destinations.clubs.title")}
                      buttonLabel={translate(
                        "dashboard.destinations.clubs.button"
                      )}
                      btnClickHandler={() =>
                        this.props.history.push("/clubList")
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          }
        />
        <SuccessMessage
          successMessage={this.props.successMessage}
          open={this.props.successMessage ? true : false}
          onClose={() => this.props.dispatch(setSuccess(null))}
          translate={this.props.translate}
        />
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    identity: state.identity,
    httpErrorMsg: state.error.httpError.message,
    successMessage: state.success.successMessage.message,
    cancelOrderItemPopup: state.flags.popupOpen.cancelOrderItemPopup
  };
};

export default connect(mapStateToProps)(translate(Dashboard));
